type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'RouteAgency'
const nameSource = 'partnerships/routesAgencies'
const namePageTitle = 'Agencies'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Agencies',
  to: '/partnerships/routesAgencies',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/partnerships/routesAgencies/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/partnerships/routesAgencies/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/partnerships/routesAgencies/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export enum ROUTE_AGENCY_PRIORITY_ENUM {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}

export const ROUTE_AGENCY_PRIORITY_MAP: Record<
  ROUTE_AGENCY_PRIORITY_ENUM,
  string
> = {
  low: 'baixa',
  medium: 'média',
  high: 'alta'
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
